/**
 * created by lei lei on 2020/6/20
 * 发文数统计组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from "echarts-for-react";
import {Input, Radio} from "antd";
import {Row, Col, Button, Modal, Checkbox, message} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import OrdinaryTrees from "../editor/OrdinaryTrees";
import *as Utils from '../../../utils'

const {Search} = Input;
let option = {
    title: {
        text: '单位：篇',//头部文字显示
        left: 50,
        top: 20,
        textStyle: {
            fontSize: '12',
            fontFamily: 'Microsoft YaHei'
        }
    },
    tooltip: {
        trigger: 'axis',
        show: true,// 必须引入 tooltip 组件,
    },
    legend: {
        bottom: 30,//提示定位
        left: 300,
        show: true,
        /* data: ['已发派', '已提交', '已完成', '进行中']*/
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '20%',
        containLabel: true
    },
    toolbox: {
        show: true,
        showTitle: false,
        feature: {}
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value',
        minInterval:1,
        //max:100
        // minInterval : 1,
        // boundaryGap : [ 0, 0.3 ],
    },
    series: [
        /*{
            name: '已发派',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#BFBFBF',
                    lineStyle:{
                        color:'#BFBFBF'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },
        {
            name: '已提交',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#FFBF00',
                    lineStyle:{
                        color:'#FFBF00'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },
        {
            name: '已完成',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#00A854',
                    lineStyle:{
                        color:'#00A854'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },
        {
            name: '进行中',
            type: 'line',
            stack: '总量',
            itemStyle : {
                normal : {
                    color:'#0E77D1',
                    lineStyle:{
                        color:'#0E77D1'
                    }
                }
            },
            data: [1,2,3,4,5,6,7,8,9,9,9,9,]
        },*/

    ]
};

export default class NumberDocumentsIssued extends Component {
    static defaultProps = {
        isUpdate: false,
        numberSelected: 3,
    };
    static propTypes = {
        option: PropTypes.object.isRequired,//图表的数据来源这个是必须属性，但是加了会报错，数据必须传递
        topBtnClick: PropTypes.func.isRequired,//顶部时间按钮点击后的回调
        isUpdate: PropTypes.bool,//是否更新子组件
    };

    constructor(props) {
        super(props);
        this.state = {
            markNumText: '净增粉丝数',
            timeText: '本周',
            colorList: ['#FFBF00', '#00A854', '#0E77D1', 'pink', 'purple', 'red', 'blue', 'yellow', 'gray'],
            visible: false,
            columName: '',
            modalList: [],
            showStatue: false,
            searchText: ''
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }


    //点击时间按钮
    handleTimeTextChange = e => {
        this.setState({timeText: e.target.value});
        this.props.topBtnClick && this.props.topBtnClick(e.target.value);
    };

    componentWillReceiveProps(nextProps, nextContext) {
       if (nextProps.isUpdate) {
           this.setState({})
        }

    }

    getDistance(arr) {
        let b = 0.2;
        for (let i = 0; i < arr.length; i++) {
            if ((i + 1) % 10 === 0) {
                b += 0.2
            }
        }
        return b * 100 + "%";
    }

    render() {
        //接受图标参数
        option.xAxis.data = this.props.option.xData;
        let colorList = this.props.option.colorList ? this.props.option.colorList : this.state.colorList;
        option.series = [];
        this.props.option.yData.forEach((item, i) => {
            option.series.push(
                {
                    name: '',
                    type: 'line',
                   // stack: '总量',
                    itemStyle: {
                        normal: {
                            color: colorList[i]?colorList[i]:this.state.colorList[i],
                            lineStyle: {
                                color: colorList[i]?colorList[i]:this.state.colorList[i]
                            }
                        }
                    },
                    data: [],
                    ...item
                }
            )
        });
        let distance = this.getDistance(this.props.option.yData);  //做适配
        option.grid = {
            containLabel: true,
            bottom: distance
        }
        option.legend = {
            bottom: 0
        }
        return (
            <div className={'NumberDocumentsIssued'} key={Utils.uuid()} style={{padding: 20}}>
                <div style={{position: 'relative', height: "100%"}}>
                    <Row>
                        <Col span={1}></Col>
                        <Col span={18}>
                            <Radio.Group style={{marginLeft: 20, paddingTop: 20}} value={this.state.timeText}
                                         onChange={this.handleTimeTextChange}>
                                <Radio.Button value="本周">本周</Radio.Button>
                                <Radio.Button value="本月">本月</Radio.Button>
                                <Radio.Button value="本年">本年</Radio.Button>
                            </Radio.Group>
                        </Col>
                        <Col span={3}>
                        </Col>

                    </Row>

                    <div style={{height: 340, width: '100%'}}>
                        <ReactEcharts
                            option={option}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%', height: '100%'}}
                        />
                    </div>

                </div>
            </div>
        )
    }

}